export default "__VITE_ASSET__ktl_SnEH__"